// === Translate Scene ===
// Small inline locale picker rendered next to the "Translate scene" toolbar
// button on the WorkflowTab. Four buttons (tr / es / en / az); clicking one
// dispatches translateSceneThunk for the currently-selected scene, then
// closes the picker. The thunk wholesale-replaces each item's params via
// UPDATE_ITEM_PARAM so the CanvasWorkflowPanel re-renders the translated
// item content without a full reload.
//
// No popup-over-popup: this is a popover anchored to the toolbar button,
// rendered inline inside the same WorkflowTab graph container as the rest of
// the workflow chrome (matching ShowCodePanel / ReviewDrawer / ActionPicker).
import React from "react";
import i18n from "i18next";
import "./TranslatePicker.scss";

// The three locales the Studio's i18n.js ships (locales/en.js, locales/es.js,
// locales/tr.js). Kept in sync with that list; if the host adds a fourth
// locale, extend this array — the middleware side accepts any string.
// "az" (Azerbaijani) is a course-content language only, not a UI locale.
export const TRANSLATE_LOCALES = [
  { code: "tr", labelKey: "Workflow.locale_tr", defaultLabel: "Türkçe" },
  { code: "es", labelKey: "Workflow.locale_es", defaultLabel: "Español" },
  { code: "en", labelKey: "Workflow.locale_en", defaultLabel: "English" },
  { code: "az", labelKey: "Workflow.locale_az", defaultLabel: "Azərbaycanca" },
];

export default function TranslatePicker({ disabled, busy, onPick, onClose }) {
  const handleClick = (code) => {
    if (disabled || busy) return;
    onPick(code);
  };

  return (
    <div className="translate-picker" data-testid="translate-picker" role="menu">
      <div className="translate-picker__header">
        <span>
          {i18n.t("Workflow.translate_picker_title", {
            defaultValue: "Translate scene to…",
          })}
        </span>
        <button
          type="button"
          className="translate-picker__close"
          onClick={onClose}
          aria-label={i18n.t("Workflow.close", { defaultValue: "Close" })}
        >
          ×
        </button>
      </div>
      <div className="translate-picker__list">
        {TRANSLATE_LOCALES.map((loc) => (
          <button
            key={loc.code}
            type="button"
            className="translate-picker__item"
            disabled={disabled || busy}
            onClick={() => handleClick(loc.code)}
            data-testid={`translate-picker__item--${loc.code}`}
          >
            <span className="translate-picker__code">{loc.code.toUpperCase()}</span>
            <span className="translate-picker__label">
              {i18n.t(loc.labelKey, { defaultValue: loc.defaultLabel })}
            </span>
          </button>
        ))}
      </div>
      {busy && (
        <div className="translate-picker__busy" data-testid="translate-picker__busy">
          {i18n.t("Workflow.translating", { defaultValue: "Translating…" })}
        </div>
      )}
    </div>
  );
}
// === /Translate Scene ===
